module.exports = __webpack_public_path__ + "img/feiji.f92a7df8.png";